angular.module 'zc.projects'

.controller 'AnalyticsProjectCtrl', ($scope, $translate, currentProject, Page, SearchFilter) ->
  Page.setBodyClass ''
  $translate('projectsAnalytics.showController.siteData').then (translation) ->
    Page.setTitle translation

  $scope.filters = SearchFilter.resolveFromLocation()
  $scope.currentProject = currentProject

  $scope.updateFilters = ->
    device = switch $scope.filters.device_value?.name
                when 'pc' then {$in:['pc', 'tablet']}
                when 'sp', 'iphone' then 'sp'
                when 'app' then 'app'
                else ''
    campaign_segment_id = $scope.filters.campaign_segment_value?.id
    $scope.updatedFilters = _.merge $scope.filters, {
      device,
      campaign_segment_id,
      is_control: '',
      start_at: moment($scope.filters.start_at).startOf('day').valueOf(),
      end_at: moment($scope.filters.end_at).endOf('day').valueOf(),
    }
    SearchFilter.set($scope.filters)
    $scope.$broadcast('filtersUpdated')

  $scope.resetFilters = ->
    $scope.$broadcast('filtersReset')

  $scope.updateFilters()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.analytics/show.controller.coffee